"use client";

import { useState, useEffect } from "react";
import { CaretCircleDown } from "@phosphor-icons/react";
import parse from "html-react-parser";
import DOMPurify from "isomorphic-dompurify";
import "./faq.css";

const FAQAccordion = ({ data = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateView = () => setIsMobile(window.innerWidth < 768);
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);

  const handleHover = (index) => {
    if (!isMobile) setActiveIndex(index);
  };

  const handleLeave = () => {
    if (!isMobile) setActiveIndex(null);
  };

  const toggleFAQ = (index) => {
    if (isMobile) {
      setActiveIndex(activeIndex === index ? null : index);
    }
  };

  if (!data || data.length === 0) {
    return <p className="text-center text-gray-500">No FAQs available.</p>;
  }

  return (
    <div className="w-full">
      {data.map((item, index) => (
        <div
          key={index}
          onMouseEnter={() => handleHover(index)}
          onMouseLeave={handleLeave}
          onClick={() => toggleFAQ(index)}
          className={`rounded-[4px] mb-[24px] shadow-sm transition-all duration-300 ${
            activeIndex === index
              ? "border border-[#0D6FEA] bg-[#E7F1FD]"
              : "border border-[#E4E4E4] bg-white"
          }`}
        >
          <div className="w-full flex justify-between gap-[16px] text-left p-[16px] md:p-[20px] cursor-pointer">
            <span className="font-[600] text-[#484848] text-[24px] md:text-[21px] w-[80%] leading-[100%]">
              {item.question}
            </span>
            <CaretCircleDown
              size={32}
              className={`transition-transform duration-500 text-[#3687EE] ${
                activeIndex === index ? "rotate-180" : ""
              }`}
            />
          </div>

          <div
            className={`overflow-hidden transition-all duration-500 ${
              activeIndex === index
                ? "max-h-200 md:max-h-50 px-[20px] pb-[20px]"
                : "max-h-0 px-[20px] pb-0"
            }`}
          >
            <div className="faq-html text-[#484848] text-[16px] leading-[100%] md:leading-[1.5] font-[400]">
              {parse(DOMPurify.sanitize(item.answer))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
